import { render, staticRenderFns } from "./Bravo.vue?vue&type=template&id=0e3f4240&scoped=true"
import script from "./Bravo.vue?vue&type=script&lang=js"
export * from "./Bravo.vue?vue&type=script&lang=js"
import style0 from "./Bravo.vue?vue&type=style&index=0&id=0e3f4240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3f4240",
  null
  
)

export default component.exports